export enum UserRole {
  IsAllegro = "isAllegro"
}